module.exports = __webpack_public_path__ + "img/partners_introduction.85a18635.svg";